//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ['images', 'size'],
  data () {
    return {
        cur_index: 0,
        axixX: 0,
        duration: '0.3s',
        interval: null,
        transitioning: false
    }
  },
  computed: {
    container_width: function () {
        return this.size.width * this.compouted_images.length + 'px'
    },
    translate3d: function () {
        return '(' + this.axixX + 'px, 0, 0)'
    },
    /**
     * 图片数据进行加工，栈顶栈底分别插入一组数据
     * 类似 3，1，2，3，1
     */
    compouted_images: function () {
        let newImages = Object.assign([], this.images)
        // 首尾分别添加对应元素
        newImages.splice(0, 0, this.images[this.images.length - 1])
        newImages.push(this.images[0])
        return newImages
    }
  },
  created: function () {
    this.axixX = -this.size.width
    // 自动播放图片
    this.interval = setInterval(this.turnToNext, 3000)
  },
  methods: {
    /**
     * 手动向前滚动图片 
     */
    turnToPre: function () {
        if (this.transitioning) {
            return
        }
        this.duration = '0.3s'
        this.transitioning = true
        if (this.cur_index === 0) {
            this.axixX += this.size.width
            this.cur_index = this.images.length - 1
        } else {
            this.axixX += this.size.width
            this.cur_index --
        }
    },
    /**
     * 手动向后滚动图片
     */
    turnToNext: function () {
        if (this.transitioning) {
            return
        }
        this.transitioning = true
        this.duration = '0.3s'
        if (this.cur_index === this.images.length - 1) {
            this.axixX -= this.size.width
            this.cur_index = 0
        } else {
            this.axixX -= this.size.width
            this.cur_index ++
        }
    },
    increment: function () {
        // 父组件触发该事件
        this.$emit('clickimg', this.cur_index)
    },
    transitionend: function () {
        if (this.cur_index === 0) {
            this.duration = 'inherit'
            this.axixX = -this.size.width
        } else if (this.cur_index === this.images.length - 1) {
            this.duration = 'inherit'
            this.axixX = -this.size.width * this.images.length
        }
        this.transitioning = false
    },
    /**
     * select pagination item
     **/
    selectItem: function (index) {
        console.log('selected' + index)
        if (this.transitioning) {
            return
        }
        this.transitioning = true
        this.duration = '0.3s'
        this.axixX = -this.size.width * (index + 1)
        this.cur_index = index
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Swiper.vue